import axios from '@/utils/axios';

// 配送中心列表
export function DistributionList() {
    return axios({
        url: '/distributionCenter/list',
        method: 'get',
        params: { },
    });
}